import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M12.3978 4.19295L5.89956 10.6912L3.6022 8.39385C3.49345 8.2851 3.31713 8.2851 3.20836 8.39385L2.94582 8.65639C2.83707 8.76513 2.83707 8.94146 2.94582 9.05023L5.70265 11.8071C5.8114 11.9158 5.98772 11.9158 6.09649 11.8071L13.0542 4.84935C13.1629 4.74061 13.1629 4.56428 13.0542 4.45551L12.7916 4.19295C12.6829 4.0842 12.5066 4.0842 12.3978 4.19295Z',
];
export const Check = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
Check.iconCategory = 'ui';
